const Backend_API = `https://innovativemultiplex.com`;
// const Backend_API = `http://localhost:8080`;
// const Backend_API =
//   process.env.REACT_APP_PayDefination_BaseUrl ||
//   process.env.REACT_APP_Dev_PayDefination_BaseUrl;

export default Backend_API;
